import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SearchIcon from '@mui/icons-material/Search';
import Button from "@mui/material/Button";
import Header from "../blocks/header";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Dashboard from "../blocks/dashboard";
import Copyright from "../blocks/copyright";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import AdminFilter from "../blocks/AdminFilter";
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    FormControl, InputAdornment, InputLabel, OutlinedInput,
    Pagination
} from "@mui/material";
import {getMahsulotlar, mahsulotDelete, messageReset} from "../store/mahsulot";

const PAGE_SIZE = 20

function Mahsulotlar(props) {
    const {t}      = useTranslation()
    const navigate = useNavigate()
    const params   = useParams()
    const is_main  = JSON.parse(localStorage.getItem('is_main'))
    const regionId = params.id || false

    const [search,        setSearch]        = useState('')
    const [page,          setPage]          = useState(1)
    const [adminRegionId, setAdminRegionId] = useState('')
    const [searchTimer,   setSearchTimer]   = useState(null)
    const [deleteItem,    setDeleteItem]    = useState(null)
    const [deleteOpen,    setDeleteOpen]    = useState(false)

    const canEdit = !is_main

    function fetchData(pg, sc, rid) {
        props.getMahsulotlar(
            pg  !== undefined ? pg  : page,
            PAGE_SIZE,
            sc  !== undefined ? sc  : search,
            rid !== undefined ? rid : (regionId || adminRegionId || '')
        )
    }

    function handleAdminFilter({regionId: r}) {
        const rid = r || ''
        setAdminRegionId(rid); setPage(1)
        props.getMahsulotlar(1, PAGE_SIZE, search, rid)
    }

    useEffect(() => { fetchData(1, '', '') }, [])
    useEffect(() => { if (props.verify === false) navigate('/login/') }, [props.verify])

    useEffect(() => {
        if (searchTimer) clearTimeout(searchTimer)
        const timer = setTimeout(() => { setPage(1); fetchData(1, search) }, 400)
        setSearchTimer(timer)
    }, [search])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'}); props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        } else if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'}); props.messageReset(); fetchData()
        }
    }, [props.message])

    function handlePage(e, v)  { setPage(v); fetchData(v); window.scrollTo({top: 0}) }

    const items       = props.mahsulotlar || []
    const showCompany = is_main || !!regionId

    return (
        <div>
            <div className={'page worker-page'}>
                <Header/><Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <div className={'header-page'} style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px'}}>
                            <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                                {t('back')}
                            </Button>
                            <h2 className={'page-title mb-0'}>{t('mahsulotlar')}</h2>
                            {canEdit && (
                                <Button variant="contained" endIcon={<AddIcon/>}
                                        onClick={() => navigate('/add-mahsulot/')}>
                                    {t('mahsulot_add')}
                                </Button>
                            )}
                        </div>

                        {is_main && !regionId && <AdminFilter onFilter={handleAdminFilter}/>}

                        <div style={{display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap'}}>
                            {showCompany && (
                                <FormControl variant="outlined" style={{minWidth: 280}}>
                                    <InputLabel>{t('search_company')}</InputLabel>
                                    <OutlinedInput value={search} onChange={e => setSearch(e.target.value)}
                                                   endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                                   label={t('search_company')}/>
                                </FormControl>
                            )}

                        </div>

                        {items.length ? (
                            <table className="table table-hover table-bordered">
                                <thead><tr>
                                    <th>#</th>
                                    {showCompany && <th>{t('title_company')}</th>}
                                    <th>{t('mahsulot_nomi')}</th>
                                    <th>{t('mahsulot_turi')}</th>
                                    <th>{t('mahsulot_olchov')}</th>
                                    <th/>
                                </tr></thead>
                                <tbody>
                                {items.map((item, index) => (
                                    <tr key={item.id}>
                                        <th>{(page-1)*PAGE_SIZE + index + 1}</th>
                                        {showCompany && <td>{item.user?.user_name || '-'}</td>}
                                        <td>{item.title}</td>
                                        <td>{item.category || '-'}</td>
                                        <td>{item.unit || '-'}</td>
                                        <td style={{whiteSpace: 'nowrap'}}>
                                            {(canEdit || is_main) && (
                                                <>
                                                    {canEdit && (
                                                        <Button variant="contained" color="info" endIcon={<EditIcon/>}
                                                                style={{marginRight: '4px'}}
                                                                onClick={() => navigate('/edit-mahsulot/' + item.id)}/>
                                                    )}
                                                    <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                                            onClick={() => { setDeleteItem(item); setDeleteOpen(true) }}/>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className={'no-infos'}>{t('no_info')}</div>
                        )}

                        {props.total_pages > 1 && (
                            <div style={{display: 'flex', justifyContent: 'center', padding: '20px 0'}}>
                                <Pagination count={props.total_pages} page={page}
                                            onChange={handlePage} color="primary" shape="rounded"/>
                            </div>
                        )}
                    </div>
                    <Copyright/>
                </Box>
            </div>

            <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
                <DialogTitle>{t('delete_title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{deleteItem?.title} — {t('delete_desc')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteOpen(false)} variant="contained">{t('cancel')}</Button>
                    <Button onClick={() => { props.mahsulotDelete(deleteItem.id); setDeleteOpen(false) }}
                            variant="contained" color="error">{t('delete')}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(
    state => state.mahsulot,
    {getMahsulotlar, mahsulotDelete, getAllVerifyResponse, messageReset}
)(Mahsulotlar)